// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.single-value-field{margin-top:1.5rem;line-height:32px;margin-bottom:16px}.single-value-field label{font-size:22px;font-weight:300}.single-value-field .value{display:block}.single-value-field .value span:first-child{padding-right:5px}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
